import {inject, Injectable, Injector, PLATFORM_ID} from '@angular/core';
import {GtmEnum} from '../models/gtm.enum';
import {v4 as uuidv4} from 'uuid';
import {OrderTrackingEntry} from '../../data/models/order-tracking-entry.model';
import {HttpClient} from '@angular/common/http';
import {DatePipe, isPlatformBrowser} from '@angular/common';
import {LoginService} from '../components/login/login.service';

@Injectable({providedIn: 'root'})
export class OrderTrackingService {
    private readonly http = inject(HttpClient);
    private readonly platformId = inject(PLATFORM_ID);
    private readonly datePipe = inject(DatePipe);
    private readonly injector = inject(Injector);
    private loginService: LoginService;

    transactionId : string;

    pushEvent(event: GtmEnum, eventData: object): void {

        if (isPlatformBrowser(this.platformId) && typeof dataLayer === "object" && "push" in dataLayer && typeof dataLayer.push === "function") {
          const filteredData: any = {...eventData['body'] ?? eventData};
          delete filteredData.registerPassword;
          delete filteredData.deliveryAddress;
          delete filteredData.billingAddress;
          delete filteredData.bonusAddress;
          delete filteredData.payment;
          delete filteredData.billingAddressList;
          delete filteredData.deliveryAddressList;
          delete filteredData.paymentList;
          delete filteredData.email;
          delete filteredData.selectedGiftList;
          delete filteredData.additionalData;

          // P5W-4011 (add userSSOId to GTM)
          if (!this.loginService) {
            // due to a circular dependency, we need to get the service from the injector rather than as attribute injection
            this.loginService = this.injector.get(LoginService);
          }
          this.loginService.getUserData().subscribe(userDataSso => {
            if(userDataSso.userSSOId) {
              filteredData.userSSOId = userDataSso.userSSOId;
            }
          });

          const pushData = {event, objectData: JSON.stringify(filteredData)};
          dataLayer.push(pushData);
        }

        if(event !== GtmEnum.SITE_NAVIGATION) {
          let eventDataList = [];
          const filteredData: any = {...eventData['body'] ?? eventData};
          if(!Array.isArray(filteredData)) {
            delete filteredData.registerPassword;
            eventDataList.push(filteredData);
          } else {
            filteredData.forEach(o => delete o.registerPassword)
            eventDataList = filteredData;
          }
          if (isPlatformBrowser(this.platformId)) {
            try {
              let orderStep = new OrderTrackingEntry();

              orderStep.ts = this.datePipe.transform(Date(), 'yyyy-MM-dd HH:mm:ss');
              orderStep.transactionId = this.transactionId;
              orderStep.eventType = event?.toString()?.toUpperCase();
              orderStep.eventData = eventDataList;

              this.http.post('webabo/tracking/orderevent', orderStep).subscribe(success => success);
            } catch (e) {
              console.error("Error while saving tracking: " + e);
            }
          }
        }
    }

    generateTransactionId(): void {
      this.transactionId = uuidv4();
    }

    getTransactionId(): string {
      return this.transactionId;
    }
}
